import * as React from "react";
const CheckLogo = (props) => (
  <svg
    width={120}
    height={120}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity={0.1} cx={60} cy={60} r={60} fill="#6B3EB4" />
    <circle
      opacity={0.3}
      cx={60.0003}
      cy={60.0003}
      r={39.2727}
      fill="#6B3EB4"
    />
    <path
      d="M59.6359 41.4546C49.6177 41.4546 41.4541 49.6182 41.4541 59.6364C41.4541 69.6546 49.6177 77.8182 59.6359 77.8182C69.6541 77.8182 77.8177 69.6546 77.8177 59.6364C77.8177 49.6182 69.6541 41.4546 59.6359 41.4546ZM68.3268 55.4546L58.0177 65.7637C57.7632 66.0182 57.4177 66.1637 57.0541 66.1637C56.6905 66.1637 56.345 66.0182 56.0905 65.7637L50.945 60.6182C50.4177 60.091 50.4177 59.2182 50.945 58.691C51.4723 58.1637 52.345 58.1637 52.8723 58.691L57.0541 62.8728L66.3996 53.5273C66.9268 53 67.7996 53 68.3268 53.5273C68.8541 54.0546 68.8541 54.9091 68.3268 55.4546Z"
      fill="#6B3EB4"
    />
    <path
      d="M52.5752 59.6659L57.4165 64.3635L66.4941 54.9683"
      stroke="white"
      strokeWidth={4.52363}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CheckLogo;
